import React from "react";
import { Link } from "react-router-dom";
import { Container, Modal, Row, Card, Col, Input, Button, UncontrolledTooltip } from "reactstrap";
import TableComponent from "../../../components/Common/TableComponent";
import { getTopics, removeTopic, upateTopicStatus } from "../../../services/topicService";
import AddTopic from "./AddTopic";
import { notifyError, notifySuccess } from "../../../utils/utils";
import PaginationComponent from "../../../components/Common/Pagination";
import Switch from "react-switch";
import SweetAlert from "react-bootstrap-sweetalert";


class Topics extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            page: 0,
            search: "",
            limit: 25,
            sort: "topic_id",
            asc: false,
            total_count: 8,
            topics: [],
            topic: {},
            alertModel: false,
            alertMessage: "",
            isEditing: false,
            modelOpen:false,
            loading: false
        };

        this.changePage = this.changePage.bind(this);                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               
        this.toggleModal = this.toggleModal.bind(this);
        this.deleteTopic = this.deleteTopic.bind(this);
    }

    
    toggleAlert(open, message, type) {
        this.setState({
            alertOpen: open,
            alertMessage: message,
            alertType: type
        });
    }

    toggleModal(value, edit) {
        this.setState({
            modelOpen: !this.state.modelOpen,
            topic: this.state.modelOpen ? {} : value,
            isEditing: value ? true : false
        })
    }


    changePage(pageNumber) {

        this.setState({ page: pageNumber });

        const req = {
            offset: pageNumber,
            limit: this.state.limit,
            search: this.state.search,
            sort: this.state.sort,
            asc: this.state.asc
        };

        this.setState({ loading: true });
        getTopics(req)
        .then(response => {
            this.setState({ loading: false });
            const { data } = response;

            if(data.status)
            {
                // console.log(data);
                this.setState({
                    topics: data.topics,
                    total_count: data.totalCount
                });
            } else {
                this.setState({
                    topics: [],
                    total_count: 0
                });
            }

        })
    }

    deleteTopic(i) {
        removeTopic(this.state.id)
        .then(res => {
            const { data } = res;
            if(data.status){
                notifySuccess(data.message);
                this.setState({ alert_confirm: false });
                this.changePage(this.state.page);
            }  else {
                notifyError(data.message);
                
            }
        });   
    }

    applySort = key => {
        console.log(key);
       if(this.state.sort === key)
       {
           this.setState({asc: !this.state.asc}, () => this.changePage(0));
       } else {
           this.setState({sort: key, asc: true}, () => this.changePage(0));
       }
    }

    componentDidMount() {
        this.changePage(0);
    }

    
    changeStatus(id, status) {
        upateTopicStatus(id, {is_active: status})
        .then(response => {
            const { data } = response;
            if(data.status) {
                notifySuccess(data.message);
                setTimeout(() => this.changePage(0) , 2000);
            } else {
                notifyError(data.message);
            }   
        });
        
    }

    render() {

        const columns = [
            // {
            //     Header: "No.",
            //     accessor: "_id",
                
            //     Cell: ({row}) => (this.state.page * 20) + (row.index + 1)
            // },
            {
                Header: () => "Topic Id" ,
                accessor: "topic_id",
                sortable : true,
                Cell: ({row}) => <span>{row.original.topic_id}</span>,
            },
            {
                Header: "Topic",
                accessor: "topic_name",
                sortable : true,
                Cell: ({row}) => {
                    return (
                        <>
                            <span>{row.original.topic_name}</span> 
                        </>
                    )
                }
            },
            {
                Header: "Active",
                accessor: "active",
                // sortable: true,
                Cell: ({row}) => 
                    <>  
                        <Switch
                            uncheckedIcon={<span>&#160;</span>}
                            checkedIcon={<span>&#160;</span>}
                            // onColor="#626ed4"
                            onColor="#02a499"
							offColor="#ec4561"
                            onChange={() => this.changeStatus(row.original.topic_id, !row.original.is_active)}
                            checked={row.original.is_active}
                            className="mr-1 mt-1"
                        />
                    </>
                
            },
            {
                Header: "Action",
                Cell: ({row}) => 
                    <>
                        {/* <Button 
                            onClick={e => { 
                                this.toggleModal(row.original);
                            }} 
                            className="mr-3 bg-white no-border"
                        >
                                <i className="mdi mdi-pencil text-primary font-size-18"></i>
                            </Button>
                     
                        <Button to={`#`} onClick={() =>  this.setState({ id: row.original.topic_id, alert_confirm: true })} className="mr-3 bg-white no-border " id="edit6"><i className="fa fa-trash text-danger font-size-18"></i></Button>
                       */}
                        <Link 
                            to={`#`} 
                            className="mr-3 text-info" id={`edit_${row.original.topic_id}`}
                            onClick={e => { 
                                this.toggleModal(row.original);
                            }}  ><i className="fa fa-edit font-size-18"></i></Link>
                        <UncontrolledTooltip placement="top" target={`edit_${row.original.topic_id}`}>
                            Edit
                        </UncontrolledTooltip >

                        <span id={`delete_${row.original.topic_id}`}><i className="text-danger fas fa-trash" onClick={e => {
                           this.setState({ id: row.original.topic_id, alert_confirm: true })
                        }}></i></span>
                        <UncontrolledTooltip placement="top" target={`delete_${row.original.topic_id}`}>
                            Delete
                        </UncontrolledTooltip >
                    </>
            }
        ];

        return (
            <React.Fragment>
                <div className="page-content">

                    <Container fluid>
                           
                        <Card>
                            <h3 className="p-3"> Topics </h3>
                            <hr />
                            <Row className="p-2">
                                <Col lg={6} md={6} sm={6} xs={6}>
                                    <Button 
                                        color="info"
                                        className="mr-3 no-border text-white"
                                        onClick={() => {
                                            this.setState({
                                                modelOpen: true,
                                                isEditing: false
                                            });
                                        }}
                                    >
                                     <i className="fas fa-plus"></i>   Add 
                                    </Button>
                                </Col>

                                <Col lg={6} md={6} sm={6} xs={6}>
                                    <div className="form-inline float-md-right">
                                        <div className="search-box ml-2">
                                            <div className="position-relative">
                                                <Input
                                                    onChange={e => {                                                        
                                                        this.setState(
                                                            { search: e.target.value },
                                                            () => this.changePage(0)
                                                          );
                                                    }}
                                                    bsSize="lg"
                                                    type="text"
                                                    name="search"
                                                    value={this.state.search}
                                                    className="form-control rounded"
                                                    placeholder="Topic"
                                                />
                                                <i className="mdi mdi-magnify search-icon"></i>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>

                            <div className="table-responsive mt-2 p-1 scrollbar" style={{ overflowY:"auto",  "height": "1000px"}}>
                                <TableComponent
                                    columns={columns}
                                    data={this.state.topics}
                                    sort={this.state.sort}
                                    asc={this.state.asc}
                                    applySort={this.applySort}
                                    loading={this.state.loading}
                                />
                            </div>
                            <div style={{"position":"absolute","bottom":"10px","width":"100%","zIndex":"99999", backgroundColor: "white"}}>
                            { 
                                this.state.total_count > 0 ? 

                                <PaginationComponent
                                total_count={this.state.total_count}
                                page={this.state.page}
                                limit={this.state.limit}
                                changePage={this.changePage}
                                changeFilter={e => {
                                    this.setState({ limit: e.target.value }, () => this.changePage(0));
                                }}
                                /> : ""
                            }
                            </div>
                        </Card>
                    </Container>
                </div>
                {this.state.alert_confirm ? (
								<SweetAlert
									title="Are you sure?"
									warning
									showCancel
									confirmBtnBsStyle="success"
									cancelBtnBsStyle="danger"
									onConfirm={() => 
										this.deleteTopic()
									}
									onCancel={() =>
										this.setState({
											alert_confirm: false,
										})
									}
								>
									You won't be able to revert this!
								</SweetAlert>
							) : null}

                
                <Modal
                    isOpen={this.state.modelOpen}
                    toggle={() => this.setState({ modelOpen: false})}
                    centered={true}
                    backdrop="static"
                >
                    <AddTopic
                        isEditing={this.state.isEditing}
                        topic={this.state.topic}
                        toggle={() => this.toggleModal({})}
                        reload={() => this.changePage(0)}
                    />
                </Modal>
            </React.Fragment>
        )
    }
}
export default Topics;